import {
  CalendarOutlined,
  EditOutlined,
  RocketOutlined,
  ScheduleOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import AppdedaloHome from '../../modules/app-views/_apps/appdedalo/home/Home';

const APP_DEDALO = {
  ID: 'appdedalo',
  NAME: 'Instituto Dédalo',
  THEME_COLOR: 'BLUE',
  THEME: 'light',
  FINTECH_SERVICES: false,
  DOMAINS: ['sistema.institutodedalo.com.br', 'sistema.dedaloribeirao.com.br'],
  '//PROFILE': [
    'singleCompany',
    'multiCompanies',
    'singleClinic',
    'multiClinics',
    'condominium',
  ],
  PROFILE: 'singleCompany',
  DEV_MODE: true,
  COPY_RIGHT: 'Infodesk Technologies',
  '//API_DEV_HOST': ['localhost', 'vps', 'heroku'],
  API_DEV_HOST: 'localhost',
  API_DEV_HTTPS: false,
  API_PORT_DEV: 8002,
  API_PORT_PRODUCTION: 8002,
  WS_PORT: 9001,
  API_HOST_DEV_LOCALHOST: 'localhost',
  API_HOST_DEV_VPS: 'vps.jarvisly.com',
  API_HOST_PRODUCTION: 'vps.jarvisly.com',
  API_HOST_DEV_HEROKU: 'dedalo.herokuapp.com',
  WHATSAPP_INTEGRATED: false,
  TOKEN: process.env.REACT_APP_APPDEDALO_TOKEN,
  LOCALE: 'pt',
  LOGO: '/apps/appdedalo/logo.png',
  LOGO_WHITE: '/apps/appdedalo/logo-white.png',
  LOGO_SM: '/apps/appdedalo/logo-sm.png',
  LOGO_SM_WHITE: '/apps/appdedalo/logo-sm-white.png',
  TITLE: 'Instituto Dédalo',
  '//SLOGAN': 'Sistema de agendamento online',
  SLOGAN2: '',
  SLOGAN_REGISTRATION: 'registration_slogan',
  SLOGAN_REGISTRATION2: '',
  APPLICATION_LAYER: 'adm',
  LOGIN_IDENTIFICATION: 'email',
  SELF_REGISTRATION: false,
  GOOGLE_LOGIN: false,
  FACEBOOK_LOGIN: false,
  RESET_PASSWORD: true,
  NAVIGATION: {
    TYPE: 'MENU',
    CONFIGURATIONS: false,
    LANGUAGES: false,
  },
  ENABLE_MARKETPLACE: false,
  HOME_MODULE: props => <AppdedaloHome {...props} />,
  MODULES: ['accounts', 'appdedaloAgendas'],
  SHOW_ALL_MENUS: !!process.env?.REACT_APP_APPDEDALO_SHOW_ALL_MENUS,
  MENU_NAVIGATION: [
    {
      key: 'records',
      path: '/app/records',
      title: 'records',
      icon: EditOutlined,
      isGroupTitle: true,
      subscriptionLevel: [0, 1],
      submenu: [
        {
          key: 'records_agendas',
          path: '/app/records/agendas',
          title: 'agendas',
          icon: CalendarOutlined,
          subscriptionLevel: [0, 1],
        },
        {
          key: 'records_candidates',
          path: '/app/records/candidates',
          title: 'candidates',
          icon: TeamOutlined,
          subscriptionLevel: [0, 1],
        },
      ],
    },
    {
      key: 'attendances',
      path: '/app/attendances',
      title: 'attendances',
      icon: RocketOutlined,
      isGroupTitle: true,
      subscriptionLevel: [0, 1],
      submenu: [
        {
          key: 'attendances_schedules',
          path: '/app/attendances/schedules',
          title: 'schedules',
          icon: ScheduleOutlined,
          subscriptionLevel: [0, 1],
        },
      ],
    },
  ],
  FIREBASE_CONFIG: JSON.parse(process.env.REACT_APP_APPDEDALO_FIREBASE_CONFIG),
};

export default APP_DEDALO;
